import { i18next } from '@yola/ws-sdk';
import ai from 'src/js/modules/ai';

const {
  constants: { textAssistantInstructions },
} = ai;

const getActions = () => [
  {
    id: textAssistantInstructions.IMPROVE,
    caption: i18next.t('Improve writing'),
    glyph: 'magic',
  },
  {
    id: textAssistantInstructions.REPHRASE,
    caption: i18next.t('Rephrase'),
    glyph: 'replace',
  },
  {
    id: textAssistantInstructions.FIX_GRAMMAR,
    caption: i18next.t('Fix grammar'),
    glyph: 'checkbox-square',
  },
  {
    id: textAssistantInstructions.MAKE_LONGER,
    caption: i18next.t('Make longer'),
    glyph: 'text-long',
  },
  {
    id: textAssistantInstructions.MAKE_SHORTER,
    caption: i18next.t('Make shorter'),
    glyph: 'text-short',
  },
  {
    id: textAssistantInstructions.TRANSLATE,
    caption: `${i18next.t('Translate to')}...`,
    glyph: 'translate',
  },
  {
    id: textAssistantInstructions.CHANGE_TONE,
    caption: `${i18next.t('Change tone to')}...`,
    glyph: 'mic-vocal',
  },
];

const getTextAssistantMenuActions = (featureFlagsManager) => {
  if (!featureFlagsManager) {
    return [];
  }

  const {
    ai_text_assistant_rewrite_v2: isAiTextAssistantRewriteV2FlagEnabled,
    ai_text_assistant_rewrite_custom: isAiTextAssistantRewriteCustomFlagEnabled,
  } = featureFlagsManager.state;

  if (!isAiTextAssistantRewriteV2FlagEnabled) {
    return [];
  }

  const menuGroups = [
    {
      name: 'quick-actions',
      items: getActions().map(({ id, glyph, caption }) => ({
        id,
        caption,
        glyph,
        iconPlacement: 'left',
        iconType: 'accent',
      })),
    },
  ];

  if (isAiTextAssistantRewriteCustomFlagEnabled) {
    menuGroups.push({
      name: 'custom',
      items: [
        {
          id: textAssistantInstructions.CUSTOM,
          caption: `${i18next.t('Custom')}...`,
          glyph: 'ai-2',
          iconPlacement: 'left',
          iconType: 'accent',
          withBetaLabel: true,
        },
      ],
    });
  }

  return menuGroups;
};

export default getTextAssistantMenuActions;
